var $80545d1b680c3cce$exports = {};
$80545d1b680c3cce$exports = {
    "replaceMessage": `Plasa\u{21B}i fi\u{219}ierul pentru a \xeenlocui`
};


export {$80545d1b680c3cce$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
